export enum LinkedDataRequestProjectStatus {
    Upcoming = 0,
    InProgress = 1,
    Completed = 2,
}

export const LinkedDataRequestProjectStatuses = [
    { key: LinkedDataRequestProjectStatus.Upcoming, label: 'Upcoming' },
    { key: LinkedDataRequestProjectStatus.InProgress, label: 'In Progress' },
    { key: LinkedDataRequestProjectStatus.Completed, label: 'Completed' },
];

export const LinkedDataRequestProjectStatusColors = {
    [LinkedDataRequestProjectStatus.Upcoming]: 'black',
    [LinkedDataRequestProjectStatus.InProgress]: 'orange',
    [LinkedDataRequestProjectStatus.Completed]: 'green',
};

export const LinkedDataRequestProjectStatusesTransitions = new Map([
    [
        LinkedDataRequestProjectStatus.Upcoming,
        new Set([
            LinkedDataRequestProjectStatus.InProgress,
            LinkedDataRequestProjectStatus.Completed,
        ]),
    ],
    [
        LinkedDataRequestProjectStatus.InProgress,
        new Set([LinkedDataRequestProjectStatus.Completed]),
    ],
    [
        LinkedDataRequestProjectStatus.Completed,
        new Set([LinkedDataRequestProjectStatus.InProgress]),
    ],
]);
